import React from 'react';
import { useTranslation } from '../../../../contexts/I18nProvider';
import { CheckCircle2, Package2 } from 'lucide-react';
import { PalletSummaryDto } from '../../../../types/picking';

interface StatusBarProps {
  completedLines: number;
  totalLines: number;
  pallets: PalletSummaryDto[];
  activePalletSSCC: string | null;
  priority: number;
}

export const StatusBar: React.FC<StatusBarProps> = ({
  completedLines,
  totalLines,
  pallets,
  activePalletSSCC,
}) => {
  const { t } = useTranslation();
  const activePallet = pallets.find(p => p.sscc === activePalletSSCC);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-3 py-1.5 sm:px-4 sm:py-2 z-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between text-xs sm:text-sm">
          <span className="flex items-center gap-1.5">
            <CheckCircle2 size={14} className="text-green-600" />
            {completedLines}/{totalLines}
          </span>

          <span className="flex items-center gap-1.5">
            <Package2 size={14} className="text-purple-600" />
            {pallets.length} {t('warehouse.modules.picking.labels.totalPallets')}
          </span>

          {activePallet && (
            <span className="flex items-center gap-1 truncate max-w-[150px]">
              <span className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></span>
              <span className="truncate text-xs">{activePallet.sscc}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
